var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamMemberNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.39 33.3532C54.3464 20.4353 46.2711 7.56654 33.3532 4.61005C20.4353 1.65356 7.56654 9.72888 4.61005 22.6468C1.65356 35.5647 9.72889 48.4335 22.6468 51.39C35.5647 54.3464 48.4335 46.2711 51.39 33.3532Z",
    stroke: "white",
    strokeWidth: 6.5947,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.39 33.3532C54.3464 20.4353 46.2711 7.56654 33.3532 4.61005C20.4353 1.65356 7.56654 9.72889 4.61005 22.6468C1.65356 35.5647 9.72889 48.4335 22.6468 51.39C35.5647 54.3464 48.4335 46.2711 51.39 33.3532Z",
    fill: "#E4E7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8538_15583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5749 12C32.2595 12 36.0873 15.8277 36.0873 20.5124C36.0873 25.197 32.2595 29.0248 27.5749 29.0248C22.8902 29.0248 19.0625 25.197 19.0625 20.5124C19.0625 15.8277 22.8331 12 27.5749 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1674 29.5957H23.9118C17.9132 29.5957 13 34.5089 13 40.5075V49.3627V49.477L13.6284 49.6483C19.3414 51.4194 24.3117 52.6762 28.368 52.6762C36.3662 52.6762 41.0509 49.7626 41.3365 49.5912L41.9078 49.3056H41.9649V40.4504C42.0221 34.4518 37.166 29.5957 31.1674 29.5957ZM29.2249 46.7347L27.6824 49.0199C27.6824 49.077 27.6253 49.077 27.5682 49.077C27.511 49.077 27.511 49.077 27.4539 49.0199L26.0257 46.7347V46.6776L26.7683 35.5944C26.7683 35.5372 26.8255 35.4801 26.8826 35.4801H28.368C28.4251 35.4801 28.4822 35.5372 28.4822 35.5944L29.2821 46.6776C29.2249 46.6776 29.2249 46.6776 29.2249 46.7347ZM28.5394 35.1373H26.7683L25.2258 31.938C25.2258 31.6524 25.4543 31.3667 25.7971 31.3667H29.5106C29.7962 31.3667 30.0819 31.5953 30.0819 31.938L28.5394 35.1373Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8538_15583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 40,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberNew);
export default __webpack_public_path__ + "static/media/team-member-new.abfe303a06ba683835b0b06f88234003.svg";
export { ForwardRef as ReactComponent };